import {
  BUNDLES_FEATURE,
  DELIVERIES_TAB,
  HIDE_INVENTORY_SECTIONS,
  SERIAL_NUMBER_HISTORY_SEARCH
} from "constants/feature-flags";
import { ADMIN_LEVEL_GROUPS } from "constants/staff";

import type { DestinationAccess } from "./destination.types";
import inSection from "./in-section.util";

const shownUnlessHiddenForStaff = ({ flags, roles }: DestinationAccess) =>
  !flags[HIDE_INVENTORY_SECTIONS] || roles.isAdminOrBusinessOwner;

export const INVENTORY_DESTINATIONS = inSection("/inventory", [
  { to: "orders", label: "Orders" },
  {
    to: "products",
    label: "Catalog",
    keywords: ["products", "services"],
    when: ({ roles }) => roles.canViewCatalog
  },
  {
    to: "clinic-stock",
    label: "Clinic Stock",
    when: shownUnlessHiddenForStaff
  },
  { to: "patient-devices", label: "Patient Devices" },
  { to: "deliveries", label: "Deliveries", featureFlag: DELIVERIES_TAB },
  {
    to: "serial-lookup",
    label: "Serial Lookup",
    featureFlag: SERIAL_NUMBER_HISTORY_SEARCH
  },
  {
    to: "inventory-docs",
    label: "Inventory Docs",
    when: ({ currentClinic }) => Boolean(currentClinic?.box_folder_id)
  },
  {
    to: "bundles",
    label: "Bundles",
    keywords: ["service bundles"],
    featureFlag: BUNDLES_FEATURE,
    when: shownUnlessHiddenForStaff
  },
  { to: "vendors", label: "Vendors", roles: ADMIN_LEVEL_GROUPS }
]);
